/* global ha */

import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import SearchBox from '@homeaway/react-searchbox-lite';
import {injectIntl} from 'react-intl';

import {setSearchData} from '../../../actions/search';
import {getSearchValues} from '../../../utils/search';
import {redirect} from '../../../actions/search';
import {isPropertyTypeAll} from '../../../utils/property-types';
import {hasAbacusTest} from '../mvt/utils/mvt';
import {TESTS, getValue} from '../../../utils/abacus';

function mapStateToProps(state) {
    return {
        details: state.destination.details,
        propertyType: state.destination.propertyType,
        lbsId: state.destination.details.lbsId,
        searchValues: state.search,
        locale: state.i18n.locale,
        site: state.config.site,
        searchBoxLiteMessages: state.i18n.translations.searchBoxLite,
        abacus: state.abacus
    };
}

function mapDispatchToprops(dispatch) {
    return {
        setSearchData,
        dispatch
    };
}

export class SearchBoxLiteComponent extends Component {
    static propTypes = {
        details: PropTypes.shape({
            fullName: PropTypes.string
        }),
        geoType: PropTypes.string,
        propertyType: PropTypes.string,
        lbsId: PropTypes.string,
        searchValues: PropTypes.shape({
            departureDate: PropTypes.string,
            arrivalDate: PropTypes.string,
            children: PropTypes.number,
            adults: PropTypes.number,
            petIncluded: PropTypes.bool
        }),
        isMobile: PropTypes.bool,
        resetForm: PropTypes.bool,
        showConsolidate: PropTypes.bool
    };

    static defaultProps = {
        isMobile: false,
        resetForm: false
    };

    componentDidMount() {
        ha.userTiming.mark('primary.action.rendered');
        ha.userTiming.mark('datepicker.active');

        const cookies = document.cookie;
        const searchCookies = getSearchValues(cookies);
        const {searchValues} = this.props;

        if (!searchCookies || !searchValues) {
            return;
        }

        const differentSearchData =
            searchValues.arrivalDate !== searchCookies.arrivalDate ||
            searchValues.departureDate !== searchCookies.departureDate ||
            searchValues.adults !== searchCookies.adults ||
            searchValues.children !== searchCookies.children ||
            searchValues.petIncluded !== searchCookies.petIncluded;

        if (differentSearchData) {
            this.props.dispatch(setSearchData(searchCookies));
        }
    }

    onSubmit = ({searchPath}) => {
        this.props.dispatch(redirect(searchPath));
    };

    render = () => {
        const {
            adults,
            children,
            petIncluded,
            departureDate,
            arrivalDate
        } = this.props.searchValues;

        const {
            lbsId,
            locale,
            searchBoxLiteMessages,
            site,
            propertyType,
            resetForm,
            abacus,
            isMobile
        } = this.props;

        const guests = {
            adultsCount: adults,
            childrenCount: children,
            petIncluded
        };

        const edapRefinements = [];
        if (!isPropertyTypeAll(this.props.propertyType)) {
            edapRefinements.push(this.props.propertyType);
        }

        const destination = resetForm ? '' : this.props.details.fullName;

        const hasExpandedTest = hasAbacusTest(abacus, TESTS.SLP_2194V);
        const showExpandedSearchBox = hasExpandedTest && getValue(abacus, TESTS.SLP_2194V) === 1;

        const searchbox = (
            <SearchBox
                lbsId={lbsId}
                destination={destination}
                checkIn={arrivalDate}
                checkOut={departureDate}
                guests={guests}
                onSubmit={this.onSubmit}
                edapDatePickerLabel={'0'}
                labels={searchBoxLiteMessages}
                locale={locale}
                isStickyMobile={isMobile}
                domain={site.domain}
                propertyType={propertyType}
                typeaheadProps={{
                    site: site.name,
                    baseUrl: `https://${site.domain}`,
                    environment: 'production'
                }}
                edapRefinements={edapRefinements}
                consolidateInputs={showExpandedSearchBox}
                datePickerIcon={showExpandedSearchBox}
                guestPickerIcon={showExpandedSearchBox}
                expandedSearchBox={showExpandedSearchBox}
                submitFromGuestPicker={!showExpandedSearchBox}
                consolidatedSearchBox={showExpandedSearchBox}
            />
        );

        return (searchbox);
    };
}

export const SearchBoxLite = injectIntl(
    connect(mapStateToProps, mapDispatchToprops)(SearchBoxLiteComponent)
);

export default SearchBoxLite;
